export default __webpack_public_path__ + "static/media/wm3.019652df.jpg";